module.exports = __webpack_public_path__ + "img/voter-template-2.897f13b2.png";